/* Video
========================================================================== */

videoIds = new Array();

function onYouTubeIframeAPIReady() {
  for (var i = video.ids.length - 1; i >= 0; i--) {
    var AutoPlay = 0;
    if (jQuery('#video_' + (i)).hasClass('autoPlaycustom')) {
      AutoPlay = 1;
    }
    videoIds[i] = new YT.Player('video_' + (i), {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: AutoPlay,
        loop: 0,
        controls: 1,
        rel: 0,
        showinfo: 0,
        autohide: 1,
        modestbranding: 1,
        vq: 'hd1080',

      },
      videoId: video.ids[i],
      events: {
        'onStateChange': onPlayerStateChange
      }
    })
  }
}

function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $el = jQuery(event.target.f);
    if($el.hasClass("hideOnEnd")){
      $el.fadeOut("slow");
      $el.next().show();
    }
  }
}

jQuery(document).on('click', '.videoPlay', function (event) {
  event.preventDefault();
  clicker = jQuery(this);
  videoIds[jQuery(this).data("video")].playVideo();
  setTimeout(function () { clicker.hide() }, 100)
});
